import { Component, OnInit, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';

import { withCurrentLocale } from '../../../../core/services/utils/keycloak-locale';
import { SpaceService } from '../../../../core/services/utils/space.service';
import { spaceOf } from '../../../../core/access/space';

/**
 * Où arriver après la connexion.
 *
 * <p>Un seul espace : on y entre. Plusieurs : le dernier choisi, s'il y en a
 * un, sinon « Continuer en tant que ». Aucun : le compte n'ouvre rien.</p>
 */
@Component({
  selector: 'app-auth-redirect',
  standalone: true,
  template: '<p>Redirecting...</p>',
})
export class AuthRedirectComponent implements OnInit {
  private readonly keycloak = inject(KeycloakService);
  private readonly router = inject(Router);
  private readonly spaces = inject(SpaceService);

  async ngOnInit(): Promise<void> {
    const isLoggedIn = await this.keycloak.isLoggedIn();

    if (!isLoggedIn) {
      await this.keycloak.login(withCurrentLocale());
      return;
    }

    const available = this.spaces.available();

    if (available.length === 0) {
      this.router.navigate(['/unauthorized']);
      return;
    }

    if (available.length === 1) {
      this.router.navigateByUrl(available[0].home);
      return;
    }

    const remembered = this.spaces.remembered();
    if (remembered) {
      this.router.navigateByUrl(spaceOf(remembered).home);
      return;
    }

    this.router.navigate(['/choose-space']);
  }
}
